/* SET STATE */
export const SET_STATE_PRODUCT = "SET_STATE_PRODUCT"

/* PRODUCTS */
export const GET_PRODUCTS = "GET_PRODUCTS"
export const GET_PRODUCTS_SUCCESS = "GET_PRODUCTS_SUCCESS"
export const GET_PRODUCTS_FAIL = "GET_PRODUCTS_FAIL"

/* PRODUCT */
export const GET_PRODUCT = "GET_PRODUCT"
export const GET_PRODUCT_SUCCESS = "GET_PRODUCT_SUCCESS"
export const GET_PRODUCT_FAIL = "GET_PRODUCT_FAIL"

/**
 * ADD PRODUCT
 */
 export const ADD_NEW_PRODUCT = "ADD_NEW_PRODUCT"
 export const ADD_PRODUCT_SUCCESS = "ADD_PRODUCT_SUCCESS"
 export const ADD_PRODUCT_FAIL = "ADD_PRODUCT_FAIL"

 /**
 * UPDATE PRODUCT
 */
export const UPDATE_PRODUCT = "UPDATE_PRODUCT"
export const UPDATE_PRODUCT_STATUS = "UPDATE_PRODUCT_STATUS"
export const UPDATE_PRODUCT_SUCCESS = "UPDATE_PRODUCT_SUCCESS"
export const UPDATE_PRODUCT_FAIL = "UPDATE_PRODUCT_FAIL"

/**
 * DELETE PRODUCT
 */
export const DELETE_PRODUCT = "DELETE_PRODUCT"
export const DELETE_PRODUCT_SUCCESS = "DELETE_PRODUCT_SUCCESS"
export const DELETE_PRODUCT_FAIL = "DELETE_PRODUCT_FAIL"
